import { ArrowRight } from "lucide-react"
import { useState } from "react"
import { DemoBookingModal } from "./demo-booking-modal"

const stats = [
  {
    value: "15M+",
    label: "Daily Transactions Processed",
  },
  {
    value: "10,000+",
    label: "Trading Partners Connected",
  },
  {
    value: "70%",
    label: "Cost Reduction vs In-House",
  },
  {
    value: "45TB",
    label: "Largest Single Data Migration",
  },
]

export function StatsSection() {
  const [demoModalOpen, setDemoModalOpen] = useState(false)

  return (
    <>
      <section className="py-16 lg:py-20 bg-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
            {stats.map((stat) => (
              <div key={stat.label} className="text-center">
                <p className="text-4xl lg:text-5xl font-bold bg-[linear-gradient(135deg,#a63083,#bf406a)] bg-clip-text text-transparent">
                  {stat.value}
                </p>
                <p className="mt-2 text-sm text-[#6b6b7b]">{stat.label}</p>
              </div>
            ))}
          </div>
          
          <div className="mt-10 text-center">
            <button 
              onClick={() => setDemoModalOpen(true)}
              className="inline-flex items-center gap-2 text-[#9e3667] hover:text-[#843054] transition-colors text-sm font-medium"
            >
              Want these numbers for your business? Let's talk
              <ArrowRight className="h-4 w-4" />
            </button>
          </div>
        </div>
      </section>

      <DemoBookingModal open={demoModalOpen} onOpenChange={setDemoModalOpen} />
    </>
  )
}
